module.exports = __webpack_public_path__ + "img/luggage-02.030c1615.svg";